import { ReactElement, useState, useCallback, useEffect, useMemo } from 'react';

import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';

import { GoBackButton, InputSearch, Pagination, Table } from '~/components';
import { ISearch } from '~/components/Pagination/Search';
import { useLoading } from '~/hooks/loading';
import { IPagination, PageOptionsRequest } from '~/models/Common';
import { IUser } from '~/models/User';
import { ProfessionalService } from '~/services';
import { applyMask } from '~/utils/masks';

import * as S from './styles';

function BillingList(): ReactElement {
  const { setLoading } = useLoading();

  const [billingList, setBillingList] = useState<IPagination<IUser[]>>({
    data: [],
    lastPage: 0,
    page: 1,
    perPage: 1,
    total: '0',
  });
  const [searchFilter, setSearchFilter] = useState('');
  const [pageOptions, setPageOptions] = useState<PageOptionsRequest>({
    page: 1,
  });
  const router = useHistory();

  const handleNavigateToProfessionalDetails = useCallback(
    (professionalId: string) => {
      router.push(`/users/details/${professionalId}`);
    },
    [router],
  );

  const handleGetBilling = async (data: ISearch) => {
    try {
      setLoading(true);

      const response = await ProfessionalService.getAllUsers(data);
      if (response.data) setBillingList(response.data);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error('Ocorreu um problema ao requisitar dados do servidor!');
    }
  };

  useEffect(() => {
    handleGetBilling({
      searchFilter,
      page: pageOptions.page,
      perpage: 8,
    });
  }, [searchFilter, pageOptions]);

  const BillingListTableMemo = useMemo(
    () => (
      <Table colsNames={['Nome', 'CPF', 'E-mail', 'Status Pagamento', '']}>
        {billingList.data?.map((user) => {
          const { professional, email, name, id } = user;
          if (!professional) return false;
          return (
            <tr
              key={professional.id}
              onClick={() => handleNavigateToProfessionalDetails(id)}
            >
              <td>{name}</td>
              <td>{applyMask({ name: 'cpf', value: professional.cpf })}</td>
              <td>{email}</td>
              <td>{professional.status}</td>
              <td>{'>'}</td>
            </tr>
          );
        })}
      </Table>
    ),
    [billingList.data, handleNavigateToProfessionalDetails],
  );

  return (
    <>
      <GoBackButton
        containerStyle={{ alignSelf: 'flex-start', paddingTop: '2.2rem' }}
      />
      <S.Container>
        <S.Header>
          <S.Title>LISTAGEM DE USUÁRIOS PAGANTES</S.Title>
          <InputSearch
            name="search"
            onSearch={(value) => setSearchFilter(value)}
            placeholder="Buscar por nome, email ou cpf"
          />
        </S.Header>
        {BillingListTableMemo}
        <S.Footer>
          {/* <Button
            textContent="Cadastrar colaborador"
            onClick={handleNavitageToMethodCadaster}
            size="small"
            variant="black"
            extraStyles={{
              maxWidth: 300,
            }}
          /> */}
          <Pagination
            pageCount={billingList.lastPage!}
            pageRangeDisplayed={3}
            {...{ setPageOptions }}
          />
        </S.Footer>
      </S.Container>
    </>
  );
}

export default BillingList;
